import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";

export function BlocklyCategory_MESSAGES(name: string = "unnamed", BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.MESSAGES, name: name, contents: [] };
  let sep = "\n ㅤㅤ";
  cat.contents = [
    BH.textarea(BLOCKLY_DUMMY.STRING, "❝", "...", "❞"),
    BH._custom("CAST_TO_TEXT", "@output:String\nals Text: {{value}}", "{{value}}", { colour: BLOCKLY_COLORS.MESSAGES_LIGHT }),
    { kind: 'block', type: 'text_join_plus_minus' },
    BH.label("Normale Nachrichten"),

    BH.withNested(BH.message("BOTMESSAGE_BLOCK", "Bot Nachricht:" + sep + "{{value}}", "await RAGAI.MSG.botMessage({{value}});"), [{ forValue: 'value', isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }]),

    BH.withNested(
      BH.message(
        "SEND_PROMPT_TXT_NEW",
        "Prompt Senden und Bot-Antwort anzeigen:" + sep + "{{value}}\nAntwort abwarten{{?wait:checkbox=true}}",
        `await RAGAI.MSG.prompt({{value}});
     if({{wait}}) {await RAGAI.WAITFOR.nextIdle();}`),

      [{ forValue: 'value', isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }]),


    BH.withNested(BH.message("SEND_PROMPT_USER_BYPASS", "Verstecke Nachricht:" + sep + "{{value}}", "await RAGAI.MSG.userBypass({{value}});"), [{ forValue: 'value', isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }]),
    BH.withNested(BH.message("SEND_PROMPT_USERMESSAGE", "Nutzer Nachricht:" + sep + "{{value}}", "await RAGAI.MSG.userMessage({{value}});"), [{ forValue: 'value', isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }])
  ];
  return cat;
}
